import {DialogueActionsStorageKeys} from "../state/DialogueActions.mjs";

const generateBackgroundImageUrl = (patternKey, defaultUrl) => {
  return patternKey === 'noPattern' ? '' : defaultUrl;
};

const getBackgroundImgStyle = imgPath => {
    return {
        backgroundImage: !!imgPath ? `url('${ imgPath }')` : 'none'
    };
};

const convertConfigValueToCorrectType = value => {
    if (typeof value === 'string') {
        if (value.toLowerCase() === 'true') {
            return true;
        }
        if (value.toLowerCase() === 'false') {
            return false;
        }
        if (!isNaN(value) && value.trim() !== '') {
            return Number(value);
        }
    }
    return value;
};

// Helper method to get the dynamic theme configs to used under PageTypes per group (changes configs based on PageType)
const getValidThemeGroupConfigs = (manifestGroupConfigs, groupValues) => {
    const result = {};
    const addConfigToResult = conf => {
        const {key} = conf;
        result[key] = conf;
    };

    Object.values(manifestGroupConfigs || {}).forEach(config => {
        const { type } = config;
        if (type === 'PageTypes') {
            const matchedPageType = (config.options || []).find(o => o.key === groupValues?.['pageTypes']);
            const defaultPageType = config.options.length > 0 ? config.options[0] : null;
            const selectedPageType = matchedPageType || defaultPageType;
            if(selectedPageType) {
                result['pageTypes'] = { ...config, label: 'Page Type' };
                Object.values(selectedPageType.configs || {}).forEach(addConfigToResult);
            }
        } else addConfigToResult(config);
    });
    return result;
}

const buildThemeSettings = (themeName, themeManifest, dbThemeSettings, isDevelopmentMode, isDemoMode) => {
    const manifestThemeSettings = _convertThemeManifestToThemeSettings(themeManifest);
    const themeRunnerLocalThemeSettings = (isDevelopmentMode && !isDemoMode) ? JSON.parse( window.localStorage.getItem(DialogueActionsStorageKeys.THEME_RUNNER_SETTINGS) ) || {} : {};
    const localThemeSettings = themeRunnerLocalThemeSettings?.themeName === themeName ? themeRunnerLocalThemeSettings?.themeSettings : {};
    const demoThemeSettings = isDemoMode ? window?.demoMode?.themeSettings || {} : {};
    const result = {};
//
    Object.keys(themeManifest).map(groupKey => {
        const defaultValues = manifestThemeSettings[groupKey] || {};
        const dbValues = dbThemeSettings?.[groupKey] || {};
        const localValues = localThemeSettings?.[groupKey] || {};
        const demoValues = demoThemeSettings?.[groupKey] || {};
        result[groupKey] = {
            ...defaultValues,
            ...dbValues,
            ...localValues,
            ...demoValues
        };
    });

    //Convert each value to correct type
    Object.keys(result).forEach(groupKey => {
        const groupConfigurations = result[groupKey];
        Object.keys(groupConfigurations).forEach(key => {
            const currentValue = result[groupKey][key];
            result[groupKey][key] = convertConfigValueToCorrectType(currentValue);
        });
    });
    return result;
};

const _convertThemeManifestToThemeSettings = (themeManifest) => {
    const result = {};
    Object.keys(themeManifest).forEach(groupKey => {
        result[groupKey] = {};
        const groupConfigurations = themeManifest[groupKey];
        Object.values(groupConfigurations).forEach((config) => {
            const { key, defaultValue, options } = config;
            const defaultOptionValue = options?.length > 0 ? options[0].key : null;
            result[groupKey][key] = convertConfigValueToCorrectType(defaultValue || defaultOptionValue);
        });
    });
    return result;
}

//TODO: consider how to connect these to portal, as these are general settings that apply to all guides
const dialogueGuideSettingsManifest = [
    { key: 'isFdicMember', label: 'Is FDIC Member?', type: 'checkbox', defaultValue: false },
    { key: 'isEhlMember', label: 'Is EHL Member?', type: 'checkbox', defaultValue: false },
    { key: 'disableProductActions', label: 'Disable Product Actions', type: 'checkbox', defaultValue: false },
    { key: 'disclosureDisplay', label: 'Show products disclosures as', type: 'Dropdown', defaultValue: 'number', options: 
    [
      { key:'bullet', label:'Bullets' },
      { key:'number', label:'Numbers' },
    ]
    },
    { key: 'contactType', label: 'Contact Method Type', type: 'Dropdown', defaultValue: 'default', options:
            [
                {key:'default', label:'Default (Basic Contact Form)'},
                {key:'emailOnly', label:'Email Only (No Lead Capture)'},
                {key:'business', label:'Business'},
                {key:'disable', label:'Disable Contact Flow'},
            ]
    },
    { key: 'showCustomerId', label: 'Show Customer ID field', type: 'checkbox', defaultValue: true },
    { key: 'contactBeforeSummary', label: 'Contact Before Summary', type: 'checkbox', defaultValue: false },
    { key: 'useTextResultsAction', label: 'Allow Users to Text Msg. Results', type:'checkbox', defaultValue: true },
    { key: 'useEmailResultsAction', label: 'Allow Users to Email Results', type:'checkbox', defaultValue: true },
    { key: 'shouldWarnOnClose', label: 'Warn Before Exit', type:'checkbox', defaultValue: false },
    { key: 'showEditAnswers', label: 'Show Edit Answers Link', type: 'checkbox', defaultValue: false }
];

const buildCommonGuideSettings = (dbSettings, isDevelopmentMode, isDemoMode) => {
    const defaultGuideSettings = {};
    dialogueGuideSettingsManifest.forEach(config => {
        const {key, defaultValue} = config;
        defaultGuideSettings[key] = defaultValue;
    });
    const localGuideSettings = (isDevelopmentMode && !isDemoMode) ? JSON.parse( window.localStorage.getItem(DialogueActionsStorageKeys.THEME_RUNNER_GUIDE_SETTINGS) ) || {} : {};
    const demoGuideSettings = isDemoMode ? window?.demoMode?.guideSettings || {} : {};
    const result = {
        ...defaultGuideSettings,
        ...dbSettings,
        ...localGuideSettings,
        ...demoGuideSettings
    };

    //Convert each value to correct type
    Object.keys(result).forEach(key => {
        const currentValue = result[key];
        result[key] = convertConfigValueToCorrectType(currentValue);
    });
    return result;
};

export {
    getBackgroundImgStyle,
    generateBackgroundImageUrl,
    buildThemeSettings,
    buildCommonGuideSettings,
    dialogueGuideSettingsManifest,
    convertConfigValueToCorrectType,
    getValidThemeGroupConfigs
}
